<script setup>
import { defineProps, ref } from 'vue';
import ProductListWithBooking from "@/components/frontend/booking/ProductListWithBooking.vue";
import ProductStoreAvailability from "@/components/frontend/booking/store/Form.vue";


const props = defineProps({
  store: {
    required: true,
  },
  availableFilters: {
    type: Object,
    default: function() {
      return {};
    }
  },
  urlProducts: {
    required: true
  },
  urlAvailability: {
    required: true,
  },
  urlBooking: {
    required: true,
  },
  urlRegistration: {
    required: true,
    type: String,
  },
  minDate: {
    type: String,
    required: true
  },
  maxDate: {
    type: String,
  },
  lifetimeInMinutes: {
    type: Number,
    default: 15,
  },
});

const isAvailable = (product) => {
  return true
}

</script>

<template>
  <ProductListWithBooking
    :url-products="urlProducts"
    :url-booking="urlBooking"
    :url-registration="urlRegistration"
    :lifetime-in-minutes="lifetimeInMinutes"
    :available-filters="availableFilters"
    :isAvailable="isAvailable"
    :base-filters="{
      store_id: store.id
    }"
  >
    <template #bookingModal="{product, onBookingSubmited}">
      <ProductStoreAvailability
        v-if="product"
        :url-availability="urlAvailability"
        :product="product"
        :store="store"
        @submitBooking="onBookingSubmited($event)"
      ></ProductStoreAvailability>
    </template>

  </ProductListWithBooking>
</template>